import { render } from "./ToOrder.vue?vue&type=template&id=479b0db6"
import script from "./ToOrder.vue?vue&type=script&lang=js"
export * from "./ToOrder.vue?vue&type=script&lang=js"

import "./ToOrder.vue?vue&type=style&index=0&id=479b0db6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__